

function getWeekDay (date) {

    const weekDays = {
        0: 'Sun',
        1: 'Mon',
        2: 'Tue',
        3: 'Wed',
        4: 'Thu',
        5: 'Fri',
        6: 'Sat',
    }

    let weekDayNum = new Date(date).getDay();

    return weekDays[weekDayNum]
}

export default getWeekDay;